window.Branch.functions.defineInitFunctionSafely('initCollectionPressQuote', function () {
    let pressQuotes = document.querySelectorAll('.press-quotes:not([data-initialized="true"])');
    pressQuotes.forEach((pressQuoteCarousel)=> {
        pressQuoteCarousel.setAttribute('data-initialized', true);
        let imagesArray = [];
        pressQuoteCarousel.querySelectorAll('.swiper-slide').forEach((slide) => {
            imagesArray.push(`${slide.getAttribute('data-nav-image')}`)
        });

        let selector = `#${pressQuoteCarousel.parentElement.id} .press-quotes .quotes`;
        let scrollBarSelector = `#${pressQuoteCarousel.parentElement.id} .swiper-scrollbar`;
        let paginationSelector = `#${pressQuoteCarousel.parentElement.id} .swiper-pagination`;

        let params = {
            slidesPerView: 1,
            spaceBetween: 0,
            freeMode: false,
            loop: false,
            autoplay: false,
            scrollbar: {
              el: `${scrollBarSelector}`,
              horizontalClass: 'swiper-scrollbar-horizontal',
              hide: false,
            },
            pagination: {
              el: `${paginationSelector}`,
              clickable: true,
              renderBullet: function (index, className) {
                return '<span class="' + className + '">' + `<img loading="lazy" width="150" height="150" sizes="170px" srcset="${window.Branch.functions.returnSrcSet(imagesArray[index])}" src="${imagesArray[index]}"/>` + '</span>';
            },
            },
            on: {
                init: function () {
                    // pressQuoteCarousel.parentElement.querySelector('.press-logos').style.opacity = '0'
                }
            }
          };
    
        var pressQuotesSwiper = new Swiper(selector, params);
      })
    })

window.addEventListener('load', function(){
  initCollectionPressQuote();
});
